// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"News_cardContainer__3pAit"};